import { player } from '@/app/entities/player'
import {
  trainingManager,
  modes,
  gsap
} from '@powerplay/core-minigames'
import { Tasks } from '../../types'
import {
  speedmeterState,
  trainingState
} from '@/stores'

/**
 * Trieda pre treningove ulohy
 */
export class TrainingTasks {

  /** Efektivita startu */
  private startUpEfficiency = 0

  /** Efektivita naskocenia */
  private jumpInEfficiency = 0

  /** tween na zobrazenie efficiency % v zakrute */
  private speedmeterTween!: gsap.core.Tween

  /** Mnozstvo taskov */
  private NUMBER_OF_TASKS = 3

  /**
   * Inicializovanie treningu
   */
  public initTraining(): void {

    trainingManager.setNumberOfTasks(this.NUMBER_OF_TASKS)

  }

  /**
   * Hlavna metoda ktoru volame pri pouziti trainingovych Taskov
   * @param task - Typu Tasks, typ ulohy ktorej hodnoty sa zadavaju
   * @param valueToCount - hodnota ktora sa zadava
   */
  public countTaskValue(task: Tasks, valueToCount: number): void {

    if (!modes.isTrainingMode()) return

    if (task === Tasks.startUp) this.countStartUpEfficiency(valueToCount)
    if (task === Tasks.jumpIn) this.countJumpInEfficiency(valueToCount)

  }

  /**
   * Vyhodnotenie nejakych veci po prejdeni zakruty
   */
  public onCurvePassed(): void {

    if (!modes.isTrainingMode()) return

    this.calculateEfficiencesAverageInCurve()
    this.countIdealLineEfficiency()

  }

  /**
   * Vypocitanie priemeru efektivity v zakrute
   */
  private calculateEfficiencesAverageInCurve(): void {

    const average = player.hillLinesManager.idealLineHelper.getActualAverageEfficiency()

    console.log('Average aktualnej zakruty bol ', average)

    if (this.speedmeterTween) this.speedmeterTween.kill()

    speedmeterState().$patch({
      visible: true,
      curveEfficiency: average
    })
    this.speedmeterTween = gsap.to({}, {
      duration: 2,
      onComplete: () => {

        speedmeterState().visible = false

      }
    })

  }

  /**
   * Metoda na vyhodnotenie startu
   * @param valueToCount - Hodnota brstartuanky
   */
  private countStartUpEfficiency(valueToCount: number): void {

    this.startUpEfficiency = valueToCount

    this.saveTaskValue(Tasks.startUp, this.getStartUpEfficiency())

  }

  /**
   * Metoda na vyhodnotenie startu
   * @param valueToCount - Hodnota brstartuanky
   */
  private countJumpInEfficiency(valueToCount: number): void {

    this.jumpInEfficiency = valueToCount

    this.saveTaskValue(Tasks.jumpIn, this.getJumpInEfficiency())

  }

  /**
   * Vyhodnotenie efektivity idealnej linie
   * @param valueToCount - Hodnota brstartuanky
   */
  private countIdealLineEfficiency(): void {

    const efficiency = player.hillLinesManager.idealLineHelper.getTotalAverageEfficiency(false)
    this.changeUI(Tasks.idealLine, efficiency)

  }

  /**
   * Hlavna privatna metoda, ktora riesi UI zmeny a trainingManager classu
   * @param name - meno tasku
   * @param value - Vyhodnotena hodnota tasku
   */
  public saveTaskValue(name: Tasks, value: number): void {

    if (!modes.isTrainingMode()) return

    value = Math.ceil(value * 10000) / 10000

    this.changeUI(name, value)
    trainingManager.setTaskValue(name, value)

  }

  /**
   * Zmena UI
   * @param name - meno tasku
   * @param value - Vyhodnotena hodnota tasku
   */
  private changeUI(name: Tasks, value: number) {

    if (!modes.isTrainingMode()) return
    console.log(`UI zmeny ${name} ma hodnotu ${value}`)
    const percent = Math.ceil(value * 100)
    const tpTask = Math.ceil(Math.round((trainingManager.getTpPerTask() * value * 10) + Number.EPSILON) / 10)
    console.log('tp task:', tpTask)

    if (tpTask !== undefined) {

      trainingState().editTask({
        text: `trainingTask4-${name}`,
        percent: String(percent),
        points: String(tpTask),
        showPoints: true
      })

    }

  }

  /**
   * Vratenie poctu percent za minute branky
   * @returns Percenta
   */
  public getStartUpEfficiency(): number {

    return this.startUpEfficiency

  }

  /**
   * Vratenie poctu percent za prejdene checkpointy
   * @returns Percenta
   */
  public getJumpInEfficiency(): number {

    return this.jumpInEfficiency

  }

  /**
   * Ulozenie poslednych uloh
   */
  public saveLastTasksValues(): void {

    if (!modes.isTrainingMode()) return

    const efficiency = player.hillLinesManager.idealLineHelper.getTotalAverageEfficiency()
    this.saveTaskValue(Tasks.idealLine, efficiency)

    console.log('FINAL DATA SENT')

  }

  /**
   * Resetovanie veci
   */
  public reset(): void {

    this.startUpEfficiency = 0
    this.jumpInEfficiency = 0
    trainingManager.resetAll()

  }

}

export const trainingTasks = new TrainingTasks()
